export const mockPaymentReminders = [
  {
    invoice_id: 'INV-1001',
    patient_id: '101',
    patient_name: 'Aryan Sharma',
    patient_email: 'aryan@example.com',
    patient_phone: '9610100479',
    total_amount: 5000,
    total_paid: 1500,
    total_discount: 0,
    remaining_amount: 3500,
    billing_cycle: 'weekly',
    session_type_id: 2,
    session_type_title: 'Regular',
    invoice_created_at: '2026-02-24',
    cycleStart: '2026-03-03',
    cycleEnd: '2026-03-09',
    cycleIndex: 1,
    daysIntoCycle: 3,
    daysRemaining: 4,
    cycleDays: 7,
    percentElapsed: 43,
    urgency: 'warning',
  },
  {
    invoice_id: 'INV-1005',
    patient_id: '104',
    patient_name: 'Pooja Mishra',
    patient_email: 'pooja@example.com',
    patient_phone: '8302285882',
    total_amount: 3000,
    total_paid: 1000,
    total_discount: 0,
    remaining_amount: 2000,
    billing_cycle: 'monthly',
    session_type_id: 3,
    session_type_title: 'MTS',
    invoice_created_at: '2026-02-01',
    cycleStart: '2026-03-03',
    cycleEnd: '2026-04-01',
    cycleIndex: 1,
    daysIntoCycle: 3,
    daysRemaining: 27,
    cycleDays: 30,
    percentElapsed: 10,
    urgency: 'info',
  },
  {
    invoice_id: 'INV-1008',
    patient_id: '108',
    patient_name: 'Ishaan Rawat',
    patient_email: 'ishaan@example.com',
    patient_phone: '9829260370',
    total_amount: 6000,
    total_paid: 800,
    total_discount: 0,
    remaining_amount: 5200,
    billing_cycle: 'daily',
    session_type_id: 7,
    session_type_title: 'Follow-Up',
    invoice_created_at: '2026-03-05',
    cycleStart: '2026-03-06',
    cycleEnd: '2026-03-06',
    cycleIndex: 1,
    daysIntoCycle: 1,
    daysRemaining: 0,
    cycleDays: 1,
    percentElapsed: 100,
    urgency: 'critical',
  },
  {
    invoice_id: 'INV-1012',
    patient_id: '112',
    patient_name: 'Sneha Verma',
    patient_email: 'sneha@example.com',
    patient_phone: '9812345678',
    total_amount: 4500,
    total_paid: 0,
    total_discount: 0,
    remaining_amount: 4500,
    billing_cycle: '15_days',
    session_type_id: 4,
    session_type_title: 'TFS',
    invoice_created_at: '2026-02-20',
    cycleStart: '2026-03-06',
    cycleEnd: '2026-03-20',
    cycleIndex: 1,
    daysIntoCycle: 0,
    daysRemaining: 14,
    cycleDays: 15,
    percentElapsed: 0,
    urgency: 'info',
  },
];

export const mockPaymentRemindersResponse = {
  rescode: 1,
  message: 'Payment reminders fetched',
  data: mockPaymentReminders,
};

export const mockSendEmailResponse = {
  rescode: 1,
  message: 'Email reminders sent successfully',
  data: { sent: 2, failed: 0, results: [] },
};
